// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyA9N_g0V4mU3O7qy4UJowlC7xYs_x1gNyc",
    authDomain: "singx-53526.firebaseapp.com",
    databaseURL: "https://singx-53526.firebaseio.com",
    projectId: "singx-53526",
    storageBucket: "singx-53526.appspot.com",
    messagingSenderId: "572326359399",
    appId: "1:572326359399:web:a3be2e27367ddc4e3bbfc2"
  },
  sgBase: 'https://singx.co',
  hkBase: 'https://hk.singx.co',
  auBase: 'https://au.singx.co',
  apiBase: 'https://api.singx.co',
  defaultCountry: 'sg'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
